(function () {
  'use strict';

  angular
    .module('app.behavior-analytics')
    .config(function ($stateProvider) {
      let analyticsPeriods = [
        {
          title: 'This Week',
          slug: 'week',
          get start() {
            return moment().subtract(6, 'days');
          },
          get end() {
            return moment();
          },
        },
        {
          title: 'Last 2 Weeks',
          slug: 'last_2_week',
          get start() {
            return moment().subtract(13, 'days');
          },
          get end() {
            return moment();
          },
        },
        {
          title: 'This Month',
          slug: 'month',
          get start() {
            return moment().subtract(1, 'month').add(1, 'day');
          },
          get end() {
            return moment();
          },
        },
        {
          title: 'This School Year',
          slug: 'year',
          get start() {
            let now = this.end,
              augustCurrentYear = moment(now).month(7).date(1),
              august;

            if (now < augustCurrentYear) {
              august = moment(`${now.year() - 1}-08-01`);
            } else {
              august = augustCurrentYear;
            }

            return august;
          },
          get end() {
            return moment();
          },
        },
        {
          title: 'All Time',
          slug: 'all_time',
          get start() {
            return moment().subtract(1, 'years');
          },
          get end() {
            return moment();
          },
        },
        {
          title: 'Custom Range',
          slug: 'custom_range',
          range: {
            startDate: moment(),
            endDate: moment().add(1, 'day'),
          },
          get start() {
            return this.range.startDate;
          },
          get end() {
            return this.range.endDate;
          },
        }
      ];

      // Now set up the states
      $stateProvider
        .state('behavior-analytics', {
          parent: 'base',
          abstract: true,
          url: '/behavior-analytics',
          templateUrl: '/app/partials/behavior-analytics/layout.html',
          data: {
            permissions: {
              //only: ['analytics'],
              redirectTo: 'addnewclass',
            },
          },
        })
        .state('behavior-analytics.quickview', {
          url: '/quickview',
          templateUrl: '/app/partials/behavior-analytics/quickview/quickview.html',
          controller: 'BehaviorQuickviewController',
          controllerAs: 'BehaviorQuickviewCtrl',
          resolve: {
            teacherTypes: function (teacherTypesService) {
              return teacherTypesService.all().then(function (types) {
                types.unshift({
                  title: 'All Teacher Subjects',
                  id: undefined,
                });

                return types;
              });
            },
            grades: function (gradesService) {
              return gradesService.all().then((grades) => {
                grades.unshift({
                  title: 'All Grades',
                  id: undefined,
                });

                return grades;
              });
            },
            periods: function () {
              return analyticsPeriods;
            },
          }
        })
        .state('behavior-analytics.subject-grade-comparisons', {
          url: '/subject-grade-comparisons',
          templateUrl: '/app/partials/behavior-analytics/subject-grade-comparisons/subject-grade-comparisons.html',
          controller: 'BehaviorSubjectGradeComparisonsController',
          controllerAs: 'BehaviorSubjectGradeComparisonsCtrl',
          resolve: {
            teacherTypes: function (teacherTypesService) {
              return teacherTypesService.all();
            },
            grades: function (gradesService) {
              return gradesService.all();
            },
              behaviorCategories: function (cannedMessagesService) {
              return cannedMessagesService.behaviorCategories().then(function (categories) {
                categories.unshift({
                  title: 'All',
                  id: undefined,
                });

                return categories;
              });
            },
            types: function (cannedMessagesService) {
              return cannedMessagesService.types().then(function (types) {
                types.unshift({
                  title: 'All',
                  id: undefined,
                });

                return types;
              });
            },
            periods: function () {
              return analyticsPeriods;
            },
          }
        })
        .state('behavior-analytics.teacher-comparisons', {
          url: '/teacher-comparisons',
          templateUrl: '/app/partials/behavior-analytics/teacher-comparisons/teacher-comparisons.html',
          controller: 'BehaviorTeacherComparisonsController',
          controllerAs: 'BehaviorTeacherComparisonsCtrl',
          resolve: {
            teacherTypes: function (teacherTypesService) {
              return teacherTypesService.all().then(function (types) {
                types.unshift({
                  title: 'All Teacher Subjects',
                  id: undefined,
                });

                return types;
              });
            },
            grades: function (gradesService) {
              return gradesService.all().then((grades) => {
                grades.unshift({
                  title: 'All Grades',
                  id: undefined,
                });

                return grades;
              });
            },
            periods: function () {
              return analyticsPeriods;
            },
          }
        })
        .state('behavior-analytics.teacher-details', {
          url: '/teacher-details',
          templateUrl: '/app/partials/behavior-analytics/teacher-details/teacher-details.html',
          controller: 'BehaviorTeacherDetailsController',
          controllerAs: 'BehaviorTeacherDetailsCtrl',
          resolve: {
            teachers: function (teachersService) {
              return teachersService.all();
            },
              categories: function (cannedMessagesService) {
              return cannedMessagesService.behaviorCategories().then(function (categories) {
                categories.unshift({
                  title: 'All',
                  id: undefined,
                });

                return categories;
              });
            },
            types: function (cannedMessagesService) {
              return cannedMessagesService.types().then(function (types) {
                types.unshift({
                  title: 'All',
                  id: undefined,
                });

                return types;
              });
            },
            periods: function () {
              return analyticsPeriods;
            },
          }
        });
    });

})();